module.exports = __webpack_public_path__ + "static/media/55_000006.cb2d50fd.jpg";